<template>
  <modal
    name="modal-personal-form"
    class="modal-dialog modal-dialog-person-form"
    :draggable="false"
    height="auto"
    :scrollable="true"
  >
    <div class="modal-content modal-content-person-form">
      <div class="modal-header">
        <h4 class="modal-title" id="modal-label" v-text="$props.args.title"></h4>
      </div>

      <div class="modal-body">
        <div class="form-group">
          <label v-html="$props.args.nickname"></label>
          <br />
          <input
            type="text"
            name="nickname"
            class="form-control input-lg"
            v-model="formData.nickname"
          />
        </div>
        <div class="form-group" v-if="$props.args.improve">
          <label v-html="$props.args.improve"></label>
          <br />
          <input
            type="text"
            name="improve"
            class="form-control input-lg"
            v-model="formData.improve"
          />
        </div>
        <div class="form-group">
          <label v-text="$props.args.code"></label>
          <br />
          <input type="text" name="code" class="form-control input-lg" v-model="formData.code" />
        </div>
        <div class="form-group">
          <label v-text="$props.args.times"></label>
          <br />
          <select class="form-control dialog-form-select input-lg" v-model="formData.times">
            <option v-for="(times, i) in $props.args.timesOption" :key="i">{{times}}</option>
          </select>
        </div>
        <div class="form-group">
          <label v-text="$props.args.age"></label>
          <br />
          <select class="form-control dialog-form-select input-lg" v-model="formData.age">
            <option v-for="(age, i) in $props.args.ageOption" :key="i">{{age}}</option>
          </select>
        </div>
        <div class="form-group">
          <label v-text="$props.args.gender"></label>
          <br />
          <select class="form-control dialog-form-select input-lg" v-model="formData.gender">
            <option v-for="(gender, i) in $props.args.genderOption" :key="i">{{gender}}</option>
          </select>
        </div>
      </div>

      <div class="modal-footer">
        <p v-show="dialogMsg" class="dialog-alert-msg">{{ $props.args.fillErrorMsg }}</p>
        <p v-show="dialogSending" class="dialog-alert-msg">
          <img src="../../assets/loading.gif" width="20" height="20" />
          <span id="span1">計算中です...</span>
        </p>
        <p v-show="dialogSending" class="dialog-alert-msg">
          <span id="span2">「計算中です」から動かない場合…</span>
          <a href="http://portal.tac-school.co.jp/faq_system/?id=39" target="_blank">
            <span id="span3">ブラウザのキャッシュをクリア</span>
          </a>
        </p>
        <button
          type="submit"
          class="btn btn-secondary btn-lg personal-form-btn"
          @click="cancel"
          v-text="$props.args.cancel"
        ></button>
        <button
          type="submit"
          class="btn btn-primary btn-lg personal-form-btn"
          @click="submit"
          v-text="$props.args.post"
        ></button>
      </div>
    </div>
  </modal>
</template>

<script>
$(".btn btn-primary btn-lg personal-form-btn").onclick = function () {
  if (window.location.href.includes("-cn")) {
    console.log("更改文本中！");
    $("#span1").html("正在计算中");
    $("#span2").html("由于“正在计算”没有动作的情况…");
    $("#span1").html("清除浏览器缓存");
  }
};
</script>

<script>
import post from "../../post";

export default {
  data: function () {
    return {
      dialogMsg: "",
      dialogSending: false,
      formData: {
        /*
              nickname: '',
              gender: '',
              age: '',
              code: '',
              */
      },
    };
  },
  props: ["level", "args"],
  methods: {
    /* 送信ボタンを押したときに、データチェック後、親コンポーネントに情報を渡す */
    submit: async function () {
      if (this.formData.nickname == null) {
        this.dialogMsg = "名前を入力してください";
        return;
      }
      if (this.$props.args.improve != null && this.formData.improve == null) {
        this.dialogMsg = "名前を入力してください";
        return;
      }

      // 待機
      this.dialogMsg = "";
      this.dialogSending = true;
      // スコア取得
      const array = this.$store.state.answerData.slice(
        0,
        this.getTotalLength(this.$props.level)
      );
      const scores = this.calcScores(this.$props.level, array);
      console.log("scores", scores);

      // jsonで送信する
      try {
        const response = await post.sendResult(
          this.formData,
          this.$store.state.answerData,
          scores,
          this.$props.level
        );
        this.$emit("on-submit");
      } catch (e) {
        console.error(e);
        this.dialogMsg = "エラーが発生しました";
        this.dialogSending = null;
      }
    },
    /* ダイアログを消す */
    cancel: function () {
      this.$modal.hide("modal-personal-form");
    },
  },
};
</script>

<style>
.card {
  margin-top: 16px;
  margin-bottom: 16px;
}

.modal-dialog-person-form {
  min-width: 100%;
  max-width: 100px;
  margin: 0;
}

.modal-content-person-form {
  min-height: 600px;
  max-height: 1000px;
  font-size: 17px;
}

.personal-form-btn {
  font-size: 2rem;
}
</style>